import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=58aa0a86&scoped=true&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"
import style0 from "./Widget.vue?vue&type=style&index=0&id=58aa0a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aa0a86",
  null
  
)

export default component.exports